import { FuelButton, FuelLink, FuelTypography } from '@frete.com/fuel-react';
import { useAppContext } from 'hooks/useAppContext';
import { useSelectAllTruckers } from 'hooks/useSelectAllTruckers';
import { useShareFreightWithTruckers } from 'hooks/useShareFreightWithTruckers';
import React from 'react';
import * as Styled from './styled';

const CheckboxOptions = () => {
  const {
    state: {
      shareFreights: { truckers },
    },
  } = useAppContext();

  const { unselectAllTruckers } = useSelectAllTruckers();
  const { handleShareFreightWithTruckers } = useShareFreightWithTruckers();

  return (
    <Styled.WrapperHeaderCheckbox>
      <div>
        <FuelLink onClick={unselectAllTruckers}>Limpar seleção</FuelLink>
      </div>

      <FuelTypography size="body-sm" weight="medium">
        {truckers.length === 1 ? `${truckers.length} selecionado` : `${truckers.length} selecionados`}
      </FuelTypography>
      <FuelButton onClick={handleShareFreightWithTruckers} variant="secondary">
        Compartilhar frete
      </FuelButton>
    </Styled.WrapperHeaderCheckbox>
  );
};

export default CheckboxOptions;
